import * as yup from "yup";
import { portugues } from "_utils/validador";

yup.setLocale(portugues);

export const ReprovarLoteSchema = yup.object().shape({
  motivo: yup.string().required("O motivo é obrigatório").min(1),
});
